const resizerStyle = {
    width: "7px",
    height: "7px",
    borderRadius: "25%",
    background: "white",
    border: "1px solid #60aff4"
}
const topRight = {
    ...resizerStyle,
    right: "-3.5px",
    top: "-3.5px"
}
const topLeft = {
    ...resizerStyle,
    left: "-3.5px",
    top: "-3.5px"
}
const bottomLeft = {
    ...resizerStyle,
    left: "-3.5px",
    bottom: "-3.5px"
}
const bottomRight = {
    ...resizerStyle,
    right: "-3.5px",
    bottom: "-3.5px"
}
const left = {
    ...resizerStyle,
    left: "-3.5px",
    top: "calc(50% - 3.5px)"
}
const right = {
    ...resizerStyle,
    right: "-3.5px",
    top: "calc(50% - 3.5px)"
}
const top = {
    ...resizerStyle,
    left: "calc(50% - 3.5px)",
    top: "-3.5px"
}
const bottom = {
    ...resizerStyle,
    left: "calc(50% - 3.5px)",
    bottom: "-3.5px"
}
const RndStyle = { top, bottom, left, right, topRight, topLeft, bottomLeft, bottomRight }
module.exports = {
    RndStyle
}




// WEBPACK FOOTER //
// ./src/components/pages/livefeed/Editor/EditorContainer/LivefeedPreview/LeftPaneView/entity/RndStyle.js